/* eslint-disable @typescript-eslint/no-explicit-any */
export function removeEmptyParams(
  params: Record<string, any>
): Record<string, any> {
  return Object.fromEntries(
    Object.entries(params).filter(([_, value]) => {
      return (
        value != null && (typeof value !== "string" || value.trim() !== "")
      );
    })
  );
}
